// Multiple Media with Text - Video Play Button Functionality
document.addEventListener('DOMContentLoaded', function() {
  const videoWrappers = document.querySelectorAll('[data-video-wrapper]');
  
  videoWrappers.forEach(wrapper => {
    const playButton = wrapper.querySelector('[data-play-button]');
    const poster = wrapper.querySelector('[data-video-poster]');
    const videoContainer = wrapper.querySelector('.multiple-media-video-container');
    const videoMedia = wrapper.querySelector('video-media');
    
    if (!playButton) return;
    
    playButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Hide poster if exists
      if (poster) {
        poster.style.display = 'none';
      }
      
      // Show video container
      if (videoContainer) {
        videoContainer.style.display = 'block';
      }
      
      // Add playing class to wrapper
      wrapper.classList.add('is-playing');
      
      // Play the video
      if (videoMedia) {
        // Trigger click on video-media to initialize if needed
        videoMedia.click();
        
        // Small delay to ensure video is ready
        setTimeout(() => {
          const video = videoMedia.querySelector('video');
          if (video) {
            video.play().catch(err => {
            });
            
            // Listen for video end/pause to show play button again
            video.addEventListener('ended', function() {
              wrapper.classList.remove('is-playing');
            }, { once: true });
            
            video.addEventListener('pause', function() {
              wrapper.classList.remove('is-playing');
            });
          }
        }, 100);
      }
    });
  });
});

